export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const ENABLE_ANALYTICS = Boolean(process.env.REACT_APP_ENABLE_ANALYTICS);

export const IS_AGENT_REACT_SNAP = navigator?.userAgent === 'ReactSnap';
